import React from "react";
import {Collapse, Link, List, ListItemButton, ListItemText} from "@mui/material";
import "./menuSubItem.scss";
import {RouteComponentProps, withRouter} from "react-router";
import useRefresh from "../../../../helpers/useRefresh";

interface MenuSubItemProps extends RouteComponentProps {
    routingAddressSubItem: string;
    subTitle: string;
    testId: string;
}

function MenuSubItem(props: MenuSubItemProps): JSX.Element {
    const pathname = props.location.pathname;
    const pathnameBase = pathname.split("/");
    const isActive = props.routingAddressSubItem.includes(`${pathnameBase[1]}/${pathnameBase[2]}`);
    const refresh = useRefresh(props.history, props.routingAddressSubItem);

    return (
        <Link
            component="div"
            onClick={() => {
                if (props.history.location.pathname === props.routingAddressSubItem) {
                    refresh();
                } else {
                    props.history.push(props.routingAddressSubItem);
                }
            }}
            className={`sub-item-wrapper ${isActive ? "active-item" : ""}`}
            data-testid={props.testId}

        >
            <Collapse in={true} timeout="auto" unmountOnExit>
                <List component="div">
                    <ListItemButton sx={{pl: 4}}>
                        <ListItemText primary={props.subTitle} className="sub-item"/>
                    </ListItemButton>
                </List>
            </Collapse>
        </Link>
    );
}

export default withRouter(MenuSubItem);
